import type { Quality } from 'amazon-ivs-player';
import type { MemberLoginParams } from '../../apis/client-side/member/type';
import SafeLocalStorage from './safe-local-storage';

type YN = 'Y' | 'N';

let shouldReceiveNotiSafeLocalStorageDefaultValue: YN = 'N';
if (typeof Notification !== 'undefined') {
  if (Notification.permission === 'granted' || Notification.permission === 'default') {
    shouldReceiveNotiSafeLocalStorageDefaultValue = 'Y';
  }
}

export const shouldReceiveNotiSafeLocalStorage = new SafeLocalStorage<YN>(
  'shouldReceiveNoti',
  shouldReceiveNotiSafeLocalStorageDefaultValue,
);

export const pandatvFontSizeSafeLocalStorage = new SafeLocalStorage<number>('pandatv-font-size');

export const adultShowAdModeSafeLocalStorage = new SafeLocalStorage<'on' | 'off'>('adultShowAdMode', 'off');

export const fanExcptSafeLocalStorage = new SafeLocalStorage<{
  managerExcpt: boolean;
  fanExcptShow: boolean;
  fanExcpt: `excpt-${number}` | string;
}>('fanExcpt', { fanExcpt: 'excpt-1', fanExcptShow: false, managerExcpt: false });

export const bjRuleAgreeSafeLocalStorage = new SafeLocalStorage<boolean>('bjRuleAgree', false);

export const fanInAudioEffectSafeLocalStorage = new SafeLocalStorage<boolean>('fanInAudioEffect', false);

export const recommendEffectSafeLocalStorage = new SafeLocalStorage<boolean>('recommendEffect', false);

export const plyrStateSafeLocalStorage = new SafeLocalStorage<{
  volume: number;
  muted: boolean;
}>('plyrState');

export const ivsQualitySafeLocalStorage = new SafeLocalStorage<Quality>('ivsQuality');
export const rtIvsQualitySafeLocalStorage = new SafeLocalStorage<Quality>('rtIvsQuality');

export const streamModeSafeLocalStorage = new SafeLocalStorage<'RT' | 'LL'>('streamMode', 'RT');

export const saveIdSafeLocalStorage = new SafeLocalStorage<MemberLoginParams['id']>('saveId');

export const deviceIdSafeLocalStorage = new SafeLocalStorage<string>('deviceId');

export const enterRenewalOnceSafeLocalStorage = new SafeLocalStorage<{
  value: boolean;
  expire: number;
}>('enter-renewal-once');

export const autoLoginSafeLocalStorage = new SafeLocalStorage<boolean>('autoLogin', false);
export const userIdSafeLocalStorage = new SafeLocalStorage<string>('userId');
export const userPwSafeLocalStorage = new SafeLocalStorage<string>('userPw');
export interface SnsLoginInfo {
  sns: 'KAKAO' | 'NAVER' | 'GOOGLE' | 'APPLE' | 'login';
  token: string;
  tokenType: string;
  tokenExpire: number;
  tokenExpireDateTime: string;
  refreshToken: string;
  refreshTokenExpire: number | string | null;
}
export const snsLoginInfoSafeLocalStorage = new SafeLocalStorage<SnsLoginInfo>('snsLoginInfo');

export const darkThemeSafeLocalStorage = new SafeLocalStorage<'dark' | 'light'>('x-theme', 'light');

export const globalChatVisibleSafeLocalStorage = new SafeLocalStorage<'true' | 'false'>('globalChatVisible');

// 메인화면의 배너 노출
export const bannerExpiresSafeLocalStorage = new SafeLocalStorage<string>('bannerExpires');

type xDeviceInfo = {
  t: 'webPc' | 'webMobile' | 'chatApp' | 'android';
  v: string; //
  ui: string | number; // useridx
  ck: {
    sessKeyAsp: string; // session key. Optional, used for ASP Authentication
  };
};
export const xDeviceInfoLocalStorage = new SafeLocalStorage<Partial<xDeviceInfo>>('xDeviceInfo', {
  t: 'webPc',
  v: '1.0',
  ui: '0',
  ck: {
    sessKeyAsp: '',
  },
});

export const aspAuthIframeBottomPaddingSafeLocalStorage = new SafeLocalStorage<number>('aspAuthIframeBottomPadding', 0);

export const adultWarningModalSafeLocalStorage = new SafeLocalStorage<{ checkedAt: number }>('adultWarningModal');

type useridx = string | number;
export const youthPolicyModalSafeLocalStorage = new SafeLocalStorage<Record<useridx, { checkedAt: number }>>(
  'youthPolicyModal',
);

export const chatSideButtonAnimationSafeLocalStorage = new SafeLocalStorage<{ cnt: number; lastAnimateAt: number }>(
  'chatSideButtonAnimation',
  { cnt: 0, lastAnimateAt: 0 },
);

export const induceSponBubbleSafeLocalStorage = new SafeLocalStorage<{ checkedAt: number }>('induceSponBubble');

export const isChatNudgeSentSafeLocalStorage = new SafeLocalStorage<boolean>('isChatNudgeSent');

export const apClickIdSafeLocalStorage = new SafeLocalStorage<string>('ap_click_id'); // 에이스플래닛 마케팅 데이터 수집용

// 한번이라도 방송을 시청한 유저인가
export const watchedLiveDateSafeLocalStorage = new SafeLocalStorage<number | null>('watchedLiveDate', null);

export const INTRO_COACH_MARK_STORAGE_KEY = 'fanza-play-intro-coach-mark-seen';
export const introCoachMarkSeenSafeLocalStorage = new SafeLocalStorage<'1'>(INTRO_COACH_MARK_STORAGE_KEY);
